// extracted by mini-css-extract-plugin
export default {"table_title":"styles_table_title__V1bbv","datetime":"styles_datetime__yOlpr","image_thumbnail":"styles_image_thumbnail__rogJH"};